var isAppInForeground = function isAppInForeground() {
  return true;
};

export { isAppInForeground };